import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=f2395ebe&scoped=true"
import script from "./Speakers.vue?vue&type=script&lang=js"
export * from "./Speakers.vue?vue&type=script&lang=js"
import style0 from "./Speakers.vue?vue&type=style&index=0&id=f2395ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2395ebe",
  null
  
)

export default component.exports